import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { PropsWithChildren } from 'react';
import { useToast } from './Toast/index';

// TODO: hack to get around react-based toast outside of react tree
let _errorToast: ((message: string) => void) | null = null;

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      // Global error handling for queries
      console.error(error); // will get picked up by Datadog RUM if configured

      const errorMessage =
        (error as Error).message || 'An unexpected error occurred.';

      if (_errorToast) {
        _errorToast(errorMessage);
      }
    },
  }),
  defaultOptions: {
    queries: {
      throwOnError: true,
    },
  },
});

export function InsureIQQueryClientProvider({ children }: PropsWithChildren) {
  const { errorToast } = useToast(); // must be within the ToastProvider

  _errorToast = errorToast;

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
